import auth from "./auth.js";
import financing from "./financing.js";
import capital from "./capital.js";
import asset from "./asset.js";

export default {
    auth,
    financing,
    capital,
    asset
};